import { Input } from 'baseui/input'

import SectionCard from '@/containers/DevToolsNew/shared/SectionCard'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import SearchResultRow from './SearchResultRow'
import TesterRow from './TesterRow'
import useBetaFeatureCard from './useBetaFeatureCard'
import { BetaFeature } from './types'
import { MutedText, SearchRow, Table, Th, Title } from './styled-components'

interface BetaFeatureCardProps {
  betaFeature: BetaFeature
}

const BetaFeatureCard = ({ betaFeature }: BetaFeatureCardProps) => {
  const {
    t,
    title,
    countryLabel,
    testers,
    hasNoTesters,
    query,
    canSearch,
    isSearching,
    onQueryChange,
    onSearchKeyDown,
    onSearch,
    results,
    hasResults,
    hasNoResults,
  } = useBetaFeatureCard(betaFeature)

  return (
    <SectionCard>
      <Title>{title}</Title>
      <MutedText>{t('beta_features.country', { country: countryLabel })}</MutedText>

      <MutedText hidden={!hasNoTesters}>{t('beta_features.no_testers')}</MutedText>
      <Table hidden={hasNoTesters}>
        <thead>
          <tr>
            <Th>{t('beta_features.table.name')}</Th>
            <Th>{t('beta_features.table.email')}</Th>
            <Th>{t('beta_features.table.added_by')}</Th>
            <Th>{t('beta_features.table.added_at')}</Th>
            <Th />
          </tr>
        </thead>
        <tbody>
          {testers.map(({ key, ...tester }) => (
            <TesterRow key={key} t={t} {...tester} />
          ))}
        </tbody>
      </Table>

      <SearchRow>
        <Input
          value={query}
          onChange={onQueryChange}
          onKeyDown={onSearchKeyDown}
          placeholder={t('beta_features.search_placeholder')}
          size='compact'
        />
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton block={false} disabled={!canSearch} isLoading={isSearching} onClick={onSearch}>
          {t('beta_features.search')}
        </SDButton>
      </SearchRow>

      <MutedText hidden={!hasNoResults}>{t('beta_features.no_results')}</MutedText>
      <Table hidden={!hasResults}>
        <tbody>
          {results.map(({ key, ...result }) => (
            <SearchResultRow key={key} t={t} {...result} />
          ))}
        </tbody>
      </Table>
    </SectionCard>
  )
}

export default BetaFeatureCard
